module.exports = __webpack_public_path__ + "img/25.4fd9b4c0.webp";